<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
    <mat-icon>account_circle</mat-icon>
</button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <button mat-menu-item (click)="handleLogout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Вихід</span>
      </button>
</mat-menu>